<!-- subdidy-details.component.html -->

<p-toast></p-toast>

<div class="card dashboardTable">
  <p-table #subsidyDetails [value]="micada1Data" [rows]="10" [paginator]="true" responsiveLayout="scroll"
    [rowHover]="true" dataKey="TAN_No"
    currentPageReportTemplate="{{ 'SHOWING' | translate }} {first} {{ 'TO' | translate }} {last} {{ 'OF' | translate }} {totalRecords} {{ 'ENTRIES' | translate }}"
    [showCurrentPageReport]="true" [loading]="loading" class="p-datatable-gridlines"
    [tableStyle]="{ 'max-width': '80rem' }">
    <!-- Caption with Search and Download -->
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <!-- Left side -->
        <div class="col-5">
          <h5 class="m-0 table-header-text">{{tableHeaderName}}</h5>
        </div>
        <!-- Middle section for buttons -->
        <div class="col-3 d-flex  justify-content-between">
          <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
            class="p-button-info mx-1"></button>
          <button type="button" pButton pRipple icon="pi pi-download" class="p-button-help"
            (click)="menu.toggle($event)" aria-haspopup="true" aria-controls="miCompletedReportMenu"></button>
          <p-menu #menu id="miCompletedReportMenu" [popup]="true" [model]="miCompletedReport"></p-menu>
        </div>
        <!-- Right side for search -->
        <div class="col-5 d-flex align-items-center justify-content-end">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="subsidyDetails.filterGlobal($any($event.target).value, 'contains')"
              placeholder="{{'SEARCH'| translate}}" />
          </span>
        </div>
      </div>
    </ng-template>


    <!-- Table Headers -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="AppID">{{ 'APP_ID' | translate }}
          <!-- <p-sortIcon field="AppID"></p-sortIcon> -->
        </th>
        <th pSortableColumn="Program_Name">{{ 'PROGRAMME_NAME' | translate }}
          <!-- <p-sortIcon field="Program_Name"></p-sortIcon> -->
        </th>
        <th pSortableColumn="Amt">{{ 'AMOUNT' | translate }}
          <!-- <p-sortIcon field="Amt"></p-sortIcon> -->
        </th>
        <th pSortableColumn="FarmerName">{{ 'FARMER_NAME' | translate }}
          <!-- <p-sortIcon field="FarmerName"></p-sortIcon> -->
        </th>
        <th pSortableColumn="VendorName">{{ 'VENDOR_NAME' | translate }}
          <!-- <p-sortIcon field="VendorName"></p-sortIcon> -->
        </th>
        <th pSortableColumn="District">{{ 'DISTRICT' | translate }}
          <!-- <p-sortIcon field="District"></p-sortIcon> -->
        </th>
        <th pSortableColumn="Block">{{ 'BLOCK' | translate }}
          <!-- <p-sortIcon field="Block"></p-sortIcon> -->
        </th>
        <th pSortableColumn="Village">{{ 'VILLAGE' | translate }}
          <!-- <p-sortIcon field="Village"></p-sortIcon> -->
        </th>
        <th pSortableColumn="PlantSpacing">{{ 'PLANT_SPACING' | translate }}
          <!-- <p-sortIcon field="PlantSpacing"></p-sortIcon> -->
        </th>
        <th pSortableColumn="RowSpacing">{{ 'ROW_SPACING' | translate }}
          <!-- <p-sortIcon field="RowSpacing"></p-sortIcon> -->
        </th>
        <th pSortableColumn="MIArea">{{ 'MI_AREA' | translate }}
          <!-- <p-sortIcon field="MIArea"></p-sortIcon> -->
        </th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-consolidateData>
      <tr class="body-section">
        <td>{{ consolidateData?.AppID }}</td>
        <td>{{ consolidateData?.Program_Name }}</td>
        <td>{{ consolidateData?.Amt | currency:'INR' }}</td>
        <td>{{ consolidateData?.FarmerName }}</td>
        <td>{{ consolidateData?.VendorName }}</td>
        <td>{{ consolidateData?.District }}</td>
        <td>{{ consolidateData?.Block }}</td>
        <td>{{ consolidateData?.Village }}</td>
        <td>{{ consolidateData?.PlantSpacing }}</td>
        <td>{{ consolidateData?.RowSpacing }}</td>
        <td>{{ consolidateData?.MIArea }}</td>
      </tr>
    </ng-template>

    <!-- Optional Table Footer -->
    <ng-template pTemplate="footer">
      <!-- You can add footer content here if needed -->
    </ng-template>
  </p-table>
</div>